import { SelectorIcon } from '@heroicons/react/outline'

export default function DragIcon() {
  return (
    <div className="inline-block align-middle cursor-grab text-gray-400 hover:text-blue-500">
      <SelectorIcon className={`h-4 w-4`} aria-hidden="true" />
    </div>
  )
}
